<template>
    <v-card class="pa-3" v-if="superUser || permission" :value="$route.path">
        <v-row class="d-flex justify-center">
            <v-col cols="12" md="12" sm="12">
                <v-card elevation="0" class="mt-1 pa-2">
                    <v-divider></v-divider>
                    <v-card-title class="subtitle-2 font-weight-medium">
                        {{ translations.mappingDescription[lang] }}
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-row justify="center" class="mt-5 mb-3">
                        <v-expansion-panels popout focusable>
                            <v-expansion-panel
                                v-for="(item, i) in eventResponses"
                                :key="item.event_name"
                                class="mb-2"
                            >
                                <v-expansion-panel-header>
                                    <template v-slot:actions>
                                        <v-icon color="primary">
                                            $expand
                                        </v-icon>
                                    </template>
                                    <span class="text-capitalize">{{
                                        item.event_name
                                    }}</span></v-expansion-panel-header
                                >
                                <v-expansion-panel-content>
                                    <v-row class="mt-3">
                                        <v-col
                                            cols="12"
                                            md="6"
                                            sm="12"
                                            class="pb-2"
                                        >
                                            <v-col
                                                cols="12"
                                                md="12"
                                                class="pa-3"
                                                style="
                                            overflow-x: auto;   
                                            background: rgba(0, 195, 255,0.1);
                                            border-radius: 8px;
                                            "
                                            >
                                                <v-col cols="12" md="12">
                                                    <span
                                                        class="text-h4 mb-3 pb-3"
                                                        >{{
                                                            translations
                                                                .responseStructure[
                                                                lang
                                                            ]
                                                        }}</span
                                                    ></v-col
                                                >
                                                <span class="mt-3 pt-3"
                                                    ><pre>{{
                                                        JSON.stringify(
                                                            item.response,
                                                            null,
                                                            2
                                                        )
                                                    }}</pre>
                                                </span>
                                            </v-col>
                                        </v-col>
                                        <v-divider vertical></v-divider>
                                        <v-col
                                            cols="12"
                                            md="6"
                                            sm="12"
                                            class="d-flex"
                                        >
                                            <v-col
                                                cols="12"
                                                md="12"
                                                class="pa-3"
                                                style="
                                            overflow-x: auto;   
                                            border-radius: 8px;
                                            "
                                                :class="[
                                                    (error.mapper[
                                                        item.event_name
                                                    ] &&
                                                        'red-area') ||
                                                        '',
                                                    (success.mapper[
                                                        item.event_name
                                                    ] &&
                                                        'green-area') ||
                                                        ''
                                                ]"
                                            >
                                                <v-col cols="12" md="12">
                                                    <span
                                                        class="text-h4 mb-3 pb-3"
                                                        >{{
                                                            translations
                                                                .responseMapping[
                                                                lang
                                                            ]
                                                        }}</span
                                                    ></v-col
                                                >
                                                <v-jsoneditor
                                                    v-if="responseMaps[i]"
                                                    :options="options"
                                                    height="940px"
                                                    :plus="false"
                                                    v-model="
                                                        responseMaps[i].response
                                                    "
                                                    @error="showJsonError(item)"
                                                ></v-jsoneditor>
                                                <v-col
                                                    cols="12"
                                                    md="12"
                                                    class="d-flex justify-center"
                                                >
                                                    <span
                                                        color="error"
                                                        v-if="
                                                            error.mapper[
                                                                item.event_name
                                                            ]
                                                        "
                                                        class="text-body-2 ma-3 pa-3 text-center red--text"
                                                        ><b>Error:</b>
                                                        {{
                                                            error.mapper[
                                                                item.event_name
                                                            ]
                                                        }}</span
                                                    ></v-col
                                                >
                                            </v-col>
                                        </v-col>
                                    </v-row>
                                    <v-col cols="12" md="12" class="pa-0">
                                        <v-toolbar
                                            flat
                                            style="background: transparent;"
                                        >
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                type="submit"
                                                :color="'secondary'"
                                                class="text-capitalize px-5"
                                                style="font-size: 0.9rem"
                                                depressed
                                                :loading="loading"
                                                :disabled="
                                                    !getPermission(
                                                        item.store_event_response_mapper_id
                                                            ? 'update'
                                                            : 'create'
                                                    ) ||
                                                        !valid.mapper[
                                                            item.event_name
                                                        ]
                                                "
                                                @click="saveMapper(item)"
                                                >{{ translations.save[lang] }}
                                            </v-btn>
                                        </v-toolbar>
                                    </v-col>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
import {
    mdiCheckCircleOutline,
    mdiMinusCircleOutline,
    mdiClose,
    mdiCheckboxMarkedOutline,
    mdiTableEye,
} from "@mdi/js";
import { mapState, mapMutations, mapActions } from "vuex";

import translations from "@/utils/translations/general/settings/developers";
import validators from "@/utils/validators/general/settings/developers/webhookResponses";

export default {
    name: "WebhookResponses",
    mixins: [translations, validators],

    data() {
        return {
            icons: {
                mdiCheckCircleOutline,
                mdiMinusCircleOutline,
                mdiClose,
                mdiCheckboxMarkedOutline,
                mdiTableEye,
            },
            detailsDialog: false,
            options: {
                mode: "code",
                mainMenuBar: false,
                statusBar: false,
                showErrorTable: false
            }
        };
    },

    computed: {
        ...mapState([
            "loading",
            "errorMessage",
            "superUser",
            "permissions",
            "storePermissions"
        ]),

        ...mapState("general/settings/developers/webhookResponses", [
            "responses",
            "mappers",
            "mapper"
        ]),

        lang() {
            return this.$route.params.lang;
        },

        permission() {
            return (
                this.superUser ||
                (this.$store.state.permissions?.developers
                    ? this.$store.state.permissions.developers
                          .webhooks_responses?.read
                    : null)
            );
        },

        eventResponses() {
            return this.responses.map(e => {
                let responseMapper =
                    this.getEventResponseMapperByEventId(e.event_id) || {};
                return {
                    ...e,
                    mapper: responseMapper.response || {},

                    store_event_response_mapper_id:
                        responseMapper.store_event_response_mapper_id || null
                };
            });
        },

        mappersData() {
            let mapData = this.mappers || [];
            if (!mapData?.length) {
                this.responses.forEach(e => {
                    mapData.push({ response: {}, event_id: e.event_id });
                });
            } else if (mapData.length < this.responses?.length) {
                this.responses.forEach(e => {
                    if (!mapData.find(x => x.event_id === e.event_id)) {
                        mapData.push({
                            response: {},
                            event_id: e.event_id,
                            store_event_response_mapper_id: null,
                            store_id: mapData[0].store_id
                        });
                    }
                });
            }
            return mapData;
        },

        responseMaps() {
            let maps = [];
            this.responses.forEach(e => {
                let map = this.mappersData.find(
                    x => x.event_id == e.event_id
                ) || {
                    response: {},
                    event_id: e.event_id,
                    store_event_response_mapper_id: null
                };
                if (Array.isArray(map?.response) && map.response.length === 0) {
                    map.response = {};
                }
                maps = [...maps, map];
            });
            return maps;
        },

        headers() {
            return [
                {
                    text: this.translations.total[this.lang],
                    value: "total",
                    align: "center"
                },
                {
                    text: this.translations.paymentStatus[this.lang],
                    value: "pending",
                    align: "center"
                },
                {
                    text: this.translations.period[this.lang],
                    value: "periodVal",
                    align: "center"
                },
                {
                    text: this.translations.payment_date[this.lang],
                    value: "updated_at",
                    align: "center"
                },
                {
                    text: this.translations.actions[this.lang],
                    value: "actions",
                    align: "center"
                }
            ];
        }
    },

    methods: {
        ...mapActions("general/settings/developers/webhookResponses", [
            "getAllResponses",
            "getEventMappers",
            "getEventMapper",
            "createEventMapper",
            "updateEventMapper"
        ]),
        ...mapMutations([
            "setDeleteDialog",
            "setNotification",
            "setLoading",
            "setErrorMessage"
        ]),

        getEventDescription(id) {
            return (
                ((this.events || []).find(x => x.id == id) || {}).description?.[
                    this.lang
                ] || ""
            );
        },

        getEventResponseMapperByEventId(id) {
            return (this.mappersData || []).find(x => x.event_id == id) || {};
        },

        async saveMapper(item) {
            this.validateMapper(item);
            if (!this.valid.mapper[item.event_name]) {
                return false;
            }
            let res;
            if (item.store_event_response_mapper_id) {
                res = await this.updateEventMapper({
                    id: item.store_event_response_mapper_id,
                    body: { response: item.mapper }
                });
            } else {
                res = await this.createEventMapper({
                    event_id: item.event_id,
                    store_id: localStorage.getItem("storeId"),
                    response: item.mapper
                });
            }
            this.setNotification({
                show: true,
                type: !res || res.error ? "error" : "success",
                text: res?.message?.replaceAll("_", " ") || "ERROR"
            });
        },

        getPermission(path) {
            return (
                this.superUser ||
                (eval(
                    "this.permissions.developers.webhooks_responses." + path
                ) &&
                    eval(
                        "this.storePermissions.developers.webhooks_responses." +
                            path
                    ))
            );
        },

        showJsonError(item) {
            // this.validateMapper(item)
            this.error.mapper[
                item.event_name
            ] = this.errorMessages.mapperInvalid[this.lang];
            this.valid.mapper[item.event_name] = false;
        }
    },

    watch: {
        permission: {
            handler(val) {
                if (!val && !this.superUser) {
                    this.$router.replace(
                        `/${this.lang}/loyaltyPanel/forbidden-gateway`
                    );
                }
            }
        }
    },

    mounted() {
        this.getAllResponses();
        this.getEventMappers();
    }
};
</script>

<style>
.event-map-input {
    align-items: stretch;
    display: flex;
    height: 100%;
}

.event-map-input .v-input__slot {
    align-items: stretch;
    display: flex;
    height: 100%;
}
.event-map-input .v-input__control {
    padding-bottom: 20px;
}
.event-map-input .v-text-field__details {
    position: absolute;
    bottom: 0;
}
.green-area {
    background: rgba(5, 236, 128, 0.1);
}
.red-area {
    background: rgba(255, 0, 0, 0.1);
}
</style>
